import React from "react";
import { FormattedMessage } from "react-intl";
import StepGuideNumbers from "../../StepGuideNumbers";
import Step4Form from "./components/Step4Form";
import useMediaQuery from "utils/hooks/useMediaQuery";
import "./styles/Step4.scss";
import StepNavigationBack from "../../StepNavigationBack";
import StepInfoContainer from "../../StepInfo/container";
import IntroductionDisclaimer from "../../IntroductionDisclaimer";

const FinalStep = () => {
  const isMobile = useMediaQuery("(max-width: 1199px)");
  const progressStepValue = 100;
  const currentStep = [0, 1, 2, 3, 4];

  return (
    <main title="step-0-form" className="step0--main">
      <StepInfoContainer
        subtitle={
          <FormattedMessage
            id="ProjectStepForm.step1.subtitle"
            description="Subtitle of Step form 1"
            defaultMessage="Formulario | Biblioteca de Proyectos"
          />
        }
        description={
          <FormattedMessage
            id="ProjectStepForm.step0.description"
            defaultMessage="El proyecto estará sujeto a aprobación del área de Mercadeo del negocio y de Mercadeo Central."
          />
        }
      />
      {isMobile && (
        <StepGuideNumbers
          currentStep={currentStep}
          progressStepValue={progressStepValue}
          isMobile={isMobile}
        />
      )}
      <section className="step0--main__wizard-form">
        {!isMobile && <StepGuideNumbers currentStep={currentStep} />}
        <div className="main__wizard-container bg-light col-12 col-lg-8 p-3 p-lg-5">
          <progress max={100} value={progressStepValue} className="w-100" />
          <StepNavigationBack isMobile={isMobile} />
          <h5 className="step0--main__form-title mt-4 font-weight-bold">
            <FormattedMessage
              id="ProjectStepForm.step4.title"
              defaultMessage="Fotos del proyecto "
            />
          </h5>
          <hr />
          <Step4Form />
        </div>
      </section>

      <IntroductionDisclaimer />
    </main>
  );
};

export default FinalStep;
